import { render, staticRenderFns } from "./ExchangeProduct.vue?vue&type=template&id=89bef990&scoped=true"
import script from "./ExchangeProduct.vue?vue&type=script&lang=js"
export * from "./ExchangeProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bef990",
  null
  
)

export default component.exports